<div class="vds-inline-alert__icon">
    <vds-icon [name]="alertIcon()" />
</div>
<div class="vds-inline-alert__content">
    @if (heading()) {
    <span class="vds-inline-alert__content-heading">{{ heading() }}</span>
    }
    <span>
        <ng-content>{{ message() }}</ng-content>
    </span>
</div>
@if (dismissible()) {
<button class="vds-inline-alert__dismiss-button" [attr.aria-label]="dismissLabel()" (click)="dismiss.emit()">
    <div class="vds-inline-alert__dismiss-button__touch-target"></div>
    <vds-icon name="close-large" />
</button>
}
